import AnimatedSection from "../components/AnimatedSection";

// --- About Section ---
const About = () => (
  <AnimatedSection id="about" className="py-24">
    <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-12 items-center">
      <div className="md:col-span-2">
        <h2 className="text-3xl font-bold text-white mb-6">
          From Code to Impact
        </h2>
        <div className="space-y-4 text-slate-400 leading-relaxed">
          <p>
            My journey in software development began with a fascination for how
            technology can solve real-world problems. Today, as a Senior Android
            Developer, that curiosity drives me to build more than just apps—I
            build tools that empower users and drive business growth.
          </p>
          <p>
            I believe the best products are born from a blend of robust
            architecture, intuitive design, and a relentless focus on the user.
            I specialize in creating scalable, maintainable codebases using
            modern practices like Clean Architecture and MVI, ensuring that
            applications are not only powerful today but also ready for the
            challenges of tomorrow.
          </p>
        </div>
      </div>
      <div className="text-center">
        <img
          src={`/images/me.jpg`}
          alt="Alan Geronimo"
          className="rounded-full shadow-lg mx-auto"
        />
      </div>
    </div>
  </AnimatedSection>
);

export default About;
